var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOpenEye(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 15,
    viewBox: "0 0 20 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 14.0001C8.35987 14.0205 6.7367 13.6665 5.254 12.9651C4.10469 12.4043 3.07265 11.6299 2.213 10.6831C1.30243 9.70422 0.585467 8.56176 0.1 7.3161L0 7.0001L0.105 6.6841C0.590815 5.43953 1.30624 4.29737 2.214 3.3171C3.07334 2.37041 4.10504 1.59596 5.254 1.0351C6.73671 0.333689 8.35988 -0.020288 10 0.000100949C11.6401 -0.0202528 13.2633 0.333723 14.746 1.0351C15.8953 1.59584 16.9274 2.37029 17.787 3.3171C18.6993 4.29466 19.4165 5.43747 19.9 6.6841L20 7.0001L19.895 7.3161C18.3262 11.3999 14.3742 14.0694 10 14.0001ZM10 2.0001C6.59587 1.89343 3.47142 3.8752 2.117 7.0001C3.4712 10.1252 6.59579 12.1071 10 12.0001C13.4041 12.1065 16.5284 10.1248 17.883 7.0001C16.5304 3.87368 13.4047 1.89118 10 2.0001ZM10 10.0001C8.55733 10.0097 7.30937 8.99746 7.02097 7.58387C6.73256 6.17029 7.48427 4.75012 8.81538 4.19376C10.1465 3.6374 11.6852 4.10024 12.4885 5.29861C13.2919 6.49698 13.1354 8.09618 12.115 9.1161C11.5563 9.68136 10.7948 9.99967 10 10.0001Z",
    fill: "#AEB1B5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpenEye);
export default __webpack_public_path__ + "static/media/openEye.f00bc07c0b3977761aae8ed600e3b8f1.svg";
export { ForwardRef as ReactComponent };